export const LANG_EN_CONFIG = {
  homePage: {
    topbar: {
      language: 'Language',
      english: 'ENGLISH',
      thai: 'THAI',
      loginRegister: 'Login/Register',
      myAddress: 'My Address',
      myOrder: 'My Purchase',
      myReturn: 'My Return',
      myVoucher: 'My Voucher',
      SignOut: 'Sign out',
      checkStatusOrder: 'Check status order.'
    },
    navbar: {
      search: 'Search',
      cart: 'Cart'
    },
    dialogSignIn: {
      signFb: 'SIGN IN WITH FACEBOOK',
      oR: 'or',
      email: 'Email',
      password: 'Password',
      forgetPassword: 'Forget password',
      resetPassword: 'Reset password',
      subReset:
        "Enter the email address associated with your account, and we'll email you a link to reset your password.",
      buttonSent: 'SEND RESET PASSWORD LINK',
      signIn: 'SIGN IN',
      name: 'Name',
      lastName: 'Last name',
      signUp: 'SIGN UP',
      dontAccount: "Don't have an account",
      alreadyHaveAnAccount: 'Already have an account?'
    },
    newArrivals: {
      newArr: 'NEW ARRIVALS',
      sale: 'SALE',
      hot: 'HOT',
      outOfStock: 'OUT OF STOCK'
    },
    categorie: {
      ACCESSORY: 'ACCESSORY',
      APPAREL: 'APPAREL',
      'COLLECTIBLES&TOYS': 'COLLECTIBLES & TOYS',
      'HOME APPLIANCES': 'APPLIANCES',
      PROMOTIONS: 'PROMOTIONS',
      EXCLUSIVE: 'EXCLUSIVE'
    },
    footer: {
      aboutus: 'about us',
      branches: 'branches',
      how: 'how to buy',
      track: "Tracking",
      fb: 'Follow Us on Facebook',
      tw: 'Follow Us on Twitter',
      ig: 'Subscribe on Instagram',
      yt: 'Watch about us on Youtube'
    }
  },
  productPage: {
    product: {
      color: 'COLOR',
      size: 'SIZE',
      material: 'MATERIAL',
      promotionCondition: 'PROMOTION CONDITION',
      only: 'Only',
      only2: 'pices left in stock',
      addToCart: 'ADD TO CART',
      buyNow: 'BUY NOW',
      share: 'SHARE',
      expireDate: 'Available until',
      promotion: 'PROMOTION',
      limit: {
        before: 'Limit',
        after: 'vouchers per time'
      }
    },
    dialogAdd: {
      title: 'SF Shop',
      bodyMessage: 'Added product to the cart success.'
    },
    dialogOutOfStock: {
      title: 'SF Shop',
      bodyMessage: 'Sorry, Product out of stock',
      close: 'Close'
    }
  },
  cartPage: {
    cartTotal: {
      cartTotals: 'CART TOTALS',
      order: 'Order',
      total: 'Total',
      subTotal: 'Sub Total',
      discountCode: 'Discount Code',
      promotion: 'Promotion',
      proceedToCheckout: 'PROCEED TO CHECKOUT',
      confirm: 'CONFIRM'
    },
    avaliableOrder: {
      cart: 'CART',
      avaliableOrder: 'AVAILIABLE ORDER',
      product: 'PRODUCT',
      price: 'PRICE',
      quantity: 'QUANTITY',
      total: 'TOTAL',
      promotion: 'Promotion'
    },
    unavaliableOrder: {
      unavaliableOrder: 'UNAVAILIABLE ORDER',
      btnDelUnAvaliableOrder: 'delete item selected'
    },
    promotionCart: {
      title: 'Promotion received'
    },
    dialogDeleteItemInCart: {
      title: 'Are you sure you want to delete ?',
      ok: 'DELETE',
      cancle: 'CANCEL'
    },
    dialogDeleteUnAvaliableItemInCart: {
      title: 'Are you sure you want to delete ?',
      bodyMessage: 'delete all item selected',
      ok: 'DELETE',
      cancle: 'CANCEL'
    },
    cartEmpty: {
      titleEmpty: 'Cart is empty',
      bodyMessage: "LET'S GO SHOPPING",
      urlMessage1: 'Back to',
      urlMessage2: 'Home'
    },
    cartBeforeConfirmOrder: {
      title: 'SF Shop',
      bodyMessage: 'Please select the product before proceed to checkout.',
      close: 'Close'
    }
  },
  checkoutPage: {
    checkout: {
      title: 'CHECKOUT',
      purchaseOrder: 'Purchase order',
      size: 'SIZE',
      color: 'COLOR',
      checking: 'Checking...'
    },
    checkoutEmpty: {
      titleEmpty: 'Checkout is empty',
      bodyMessage: "LET'S GO SHOPPING",
      urlMessage1: 'Back to',
      urlMessage2: 'Home'
    },
    PurchaseOrderTableHeader: {
      Product: 'Product',
      Price: 'Price',
      Quantity: 'Quantity',
      Total: 'Total'
    },
    shippingAddress: {
      title: 'SHIPPING ADDRESS',
      add: 'Add address',
      default: 'Default',
      change: 'Change',
      manageAddress: 'Manage address',
      ok: 'SAVE',
      cancel: 'CANCEL'
    },
    EmailAddress: {
      title: 'EMAIL ADDRESS'
    },
    taxInvoiceAddress: {
      title: 'TAX INVOICE ADDRESS',
      add: 'Add tax invoice address',
      default: 'Default',
      change: 'Change',
      manageAddress: 'Manage address',
      ok: 'SAVE',
      cancel: 'CANCEL'
    },
    paymentMethod: {
      title: 'SELECT PAYMENT METHOD',
      creditDebitCard: 'CREDIT / DEBIT CARD',
      sfPlus: 'SF PLUS',
      qrCode: 'QR CODE',
      sfPlusBalance: 'Balance',
      sfPlusWallet: 'SF Plus Wallet'
    },
    submit: {
      subtotal: 'Subtotal',
      shipping: 'Shipping',
      total: 'Total',
      reqInvTax: 'Request a tax invoice',
      purchase: 'PURCHASE',
      promotion: 'Promotion'
    },
    dialogPin: {
      title: 'SF Plus PIN',
      inputPin: 'Pin',
      ok: 'CHECK',
      cancle: 'CLOSE'
    },
    dialogThaiQR: {
      title: 'QR CODE PAYMENT',
      WaitingForPayment: 'Waiting for payment...',
      PaymentCompleted: 'Payment completed',
      WaitingForQRcode: 'Just a moment please.'
    },
    dialogConfirmCancelThaiQr: {
      title: "Do you want to cancel payment ?",
      yes: "YES",
      no: "NO"
    },
    dialogPolicy: {
      title: 'SF Shop',
      bodyMessage: {
        title:
          'นโยบายการเปลี่ยนสินค้า คืนสินค้าและคืนเงิน กรณีซื้อสินค้าผ่านช่องทางออนไลน์',
        paragraph1: `ผู้ซื้อสามารถแจ้งความประสงค์เพื่อทำการขอเปลี่ยนสินค้า/คืนสินค้าและขอรับเงินคืนได้ ในกรณีที่สินค้าเข้าเงื่อนไขดังต่อไปนี้ โดยผู้ซื้อจะต้องส่งสินค้ากลับภายใน 7 วันหลังจากได้รับสินค้า และทางบริษัทฯ จะทำการคืนเงินให้ ภายใน 15 วันทำการ หรือตามเงื่อนไขของทางธนาคาร`,
        paragraph2:
          'ก. สินค้ามีตำหนิ คือ สินค้าที่เสียหายทางกายภาพ เช่น บุบ มีตำหนิ เมื่อส่งถึงมือลูกค้าและ/หรืออยู่ในบรรจุภัณฑ์ที่ชำรุด',
        paragraph3:
          'ข. สินค้าผิด/ไม่ถูกต้อง คือ สินค้าที่ได้รับมีความแตกต่างจากหรือไม่ตรงกับหน้าเว็ปไซต์/ไม่ตรงกับที่สั่งซื้อ',
        paragraph4:
          'ค. สินค้า / อุปกรณ์ หรือชิ้นส่วนของสินค้าสูญหายหรือได้รับไม่ครบ รวมทั้งสินค้าไม่สามารถใช้การได้ คือ อุปกรณ์ ชิ้นส่วนสินค้า หรือฟังก์ชันการใช้งานไม่เป็นไปตามที่อธิบายไว้ในคู่มือสินค้า',
        paragraph5:
          'ง. สินค้าไม่ตรงตามข้อมูลบนเว็ปไซต์ สินค้าที่ได้รับไม่ตรงตามรายละเอียดที่แจ้งบนเว็ปไซต์ เช่น รูป ลักษณะสินค้า ลวดลาย วัสดุที่ใช้ และอื่นๆ',
        paragraph6:
          '1. การเปลี่ยนสินค้า ผู้ซื้อสามารถแจ้งความประสงค์เพื่อเปลี่ยนสินค้าได้ภายใน 7 วันนับจากวันได้รับสินค้า',
        paragraph7:
          '1.1 การเปลี่ยนสินค้า บริษัทฯ ขอสงวนสิทธิ์ สินค้าที่เปลี่ยนใหม่ต้องเป็นสินค้ารายการเดียวกันกับที่ผู้ซื้อได้ทำการซื้อแล้วเท่านั้น โดยผู้ซื้อสามารถแจ้งเปลี่ยนเฉพาะสินค้าที่มีปัญหาได้ 1 รอบ/คำสั่งซื้อเท่านั้น',
        paragraph8:
          '1.2 การเปลี่ยนสินค้า บริษัทฯ และผู้ซื้อต้องยินยอมร่วมกันทั้งสองฝ่าย บริษัทฯ ขอสงวนสิทธิ์สามารถปฏิเสธการเปลี่ยนสินค้าได้หากมีเหตุผลที่เหมาะสม',
        paragraph9:
          '1.3 ในการเปลี่ยนสินค้า ผู้ซื้อต้องส่งสินค้ากลับคืนมายังบริษัทฯ ภายใน 7 วัน นับจากวันที่ได้รับสินค้าตามวันที่ประทับตราขนส่ง หากเกินจากระยะเวลาที่กำหนด บริษัทฯ ขอสงวนสิทธิ์ในการไม่รับเปลี่ยนสินค้าทุกกรณี',
        paragraph10:
          '1.4 ผู้ซื้อนำส่งสินค้าที่ต้องการเปลี่ยนมาที่สำนักงานใหญ่ บริษัท เอส เอฟ คอร์ปอเรชั่น จำกัด (มหาชน) ทั้งนี้ผู้ซื้อต้องเป็นผู้รับผิดชอบค่าจัดส่งสินค้ากลับคืนบริษัทฯ เอง ยกเว้น กรณีบริษัทฯ ส่งสินค้าผิด บริษัทฯ จะเป็นผู้รับผิดชอบค่าส่งสินค้า',
        paragraph11:
          '1.5 ระยะเวลาในการดำเนินการเปลี่ยนสินค้า 7-15 วันทำการ นับจากวันที่สำนักงานใหญ่ ได้รับสินค้า',
        paragraph12:
          '1.6 กรณีผู้ซื้อมิได้ส่งสินค้ากลับมายังบริษัทฯ ทางบริษัทฯ ขอสงวนสิทธิ์ไม่ดำเนินการเปลี่ยนสินค้าหรือคืนเงินให้แก่ลูกค้า',
        paragraph13:
          '1.7 บริษัทฯ ขอสงวนสิทธิ์ในการรับเปลี่ยนสินค้าภายใต้นโยบายและเงื่อนไขตามที่บริษัทฯ กำหนดเท่านั้น',
        paragraph14:
          '1.8 บริษัทฯ ขอสงวนสิทธิ์ในการเปลี่ยนแปลง แก้ไข เงื่อนไขการเปลี่ยนสินค้าโดยมิต้องแจ้งให้ทราบล่วงหน้า',
        paragraph15:
          '2.การคืนสินค้าและขอรับเงินคืนบริษัทจะทำการคืนเงินให้ในกรณีสินค้าที่ผู้ซื้อต้องการเปลี่ยนไม่มีสต็อคเท่านั้นโดยบริษัทฯ จะทำการคืนเงินให้ ภายใน 15 วันทำการ นับจากวันที่สำนักงานใหญ่ได้รับสินค้า',
        paragraph16: 'ช่องทางการติดต่อ',
        paragraph17: 'E-mail = SFshop@sfcinema.com'
      },
      ok: 'ACCEPT',
      cancle: 'CLOSE'
    },
    dialogSFPlusInfo: {
      title: 'SF Shop',
      linked: 'Your account not linked SF Plus',
      balance: 'Balance not enough',
      close: 'CLOSE'
    },
    dialogPhoneNumber: {
      title: 'Phone Number',
      phoneNumber: 'Phone Number',
      ok: 'Done',
      cancel: 'Cancel'
    },
    dialogFurtherInformation: {
      title: 'Information for shipping',
      email: 'Email',
      name: 'Name',
      lastname: 'Last name',
      phoneNumber: 'Phone Number',
      ok: 'Done',
      cancel: 'Cancel'
    },
    selectShipping: {
      title: "SHIPPING",
      errorBranch: "^Not included in the list.",
      postOffice: "Post Office",
      branch: "Branch",
      shippingBranch: {
        title: "SHIPPING BRANCH",
        selectBranch: "Select branch",
        phoneNumber: "Phone number"
      }
    }
  },
  SearchPage: {
    search: {
      title: 'SEARCH'
    },
    categories: {
      title: 'CATEGORIES'
    }
  },
  notFoundPage: {
    title: '404 Page not found',
    bodyMessage: 'Unable to find that content.',
    urlMessage1: 'Back to',
    urlMessage2: 'Home'
  },
  paymentvoucherSuccessPage: {
    title: 'Payment success',
    bodyMessage: {
      line1: 'Your order has been completed.',
      line2: 'You will receive transaction details via registered email,',
      line3:
        'If you do not receive an email, please contact the staff through the contact methods from below.'
    },
    urlMessage1: 'Back to',
    urlMessage2: ' My Voucher'
  },
  paymentSuccessPage: {
    title: 'Payment success',
    bodyMessage: {
      line1: 'Your order has been completed.',
      line2: 'You will receive transaction details via registered email,',
      line3:
        'If you do not receive an email, please contact the staff through the contact methods from below.'
    },
    urlMessage1: 'Back to',
    urlMessage2: ' My Purchase'
  },
  paymentFailurePage: {
    title: 'PAYMENT FAILURE',
    bodyMessage: 'SOMETHING WENT WRONG.',
    urlMessage1: 'Back to',
    urlMessage2: 'My Purchase'
  },
  paymentCancelledPage: {
    title: 'PAYMENT CANCELLED',
    bodyMessage: 'PAYMENT WAS CANCELLED BY USER',
    urlMessage1: 'Back to',
    urlMessage2: 'My Purchase'
  },
  purchase: {
    YourOrder: 'Your order history is empty.',
    invoiceNo: 'ORDER NO :',
    orderDate: 'ORDER DATE :',
    status: 'STATUS :',
    deliveryNo: 'DELIVERY NO :',
    product: 'Product',
    price: 'Price',
    quantity: 'Quantity',
    color: 'Color:',
    shippingAddress: 'SHIPPING ADDRESS :',
    taxInvoiceAddress: 'TAX INVOICE ADDRESS :',
    subtotal: 'Subtotal',
    shipping: 'Shipping',
    total: 'Total',
    discount: 'Discount',
    buttonRating: 'Rating',
    buttonBuyAgain: 'Buy Again',
    pickUpBranch: 'PICK UP AT THE BRANCH :',
    since: 'SINCE :'
  },
  usermenu: {
    myAccount: 'MY ACCOUNT',
    purchase: {
      myPurchase: 'MY PURCHASE',
      all: 'All',
      failed: 'Failed',
      pending: 'Pending',
      shipping: 'Shipping',
      delivered: 'Delivered',
      return: 'Change/Return',
      formCheckStatusOrder: {
        title: 'Check status order.',
        invoice: 'Order No.',
        phoneNumber: 'Phone number',
        ok: 'Done'
      }
    },
    address: {
      myAddress: 'MY ADDRESS',
      shippingAddress: {
        title: 'Shipping address',
        name: 'Name',
        address: 'Address',
        phone: 'Phone number',
        add: 'Add',
        edit: 'Edit',
        delete: 'Delete',
        default: 'Default',
        setdefault: 'Set as default',
        notHaveShippingAddress: 'You have not set a shipping address'
      },
      taxInvoiceAddress: {
        title: 'Tax invoice address',
        name: 'Name',
        taxId: 'Tax No.',
        address: 'Address',
        phone: 'Phone number',
        email: 'Email',
        add: 'Add',
        edit: 'Edit',
        delete: 'Delete',
        default: 'Default',
        setdefault: 'Set as default',
        notHaveTaxInvoiceAddress: 'You have not set a tax invoice address'
      },
      dialogShippingAddress: {
        titleCreate: 'SHIPPING ADDRESS',
        titleChange: 'UPDATE SHIPPING ADDRESS',
        name: 'Name',
        lastName: 'Last name',
        address: 'Address',
        province: 'Select Province',
        district: 'Select district',
        subDistrict: 'Select Sub-district',
        zipcode: 'Zipcode',
        phoneNumber: 'Phone number',
        default: 'Default',
        email: 'Email',
        ok: 'SAVE',
        cancle: 'CLOSE'
      },
      dialogTaxInvoiceAddress: {
        titleCreate: 'TAX INVOICE ADDRESS',
        titleChange: 'UPDATE TAX INVOICE ADDRESS',
        name: 'Name - Lastname / Company Name',
        taxId: 'Tax No.',
        phoneNumber: 'Phone number',
        email: 'Email',
        address: 'Address',
        province: 'Province',
        district: 'District',
        subDistrict: 'Select Sub-district',
        zipcode: 'Zipcode',
        default: 'Default',
        ok: 'SAVE',
        cancle: 'CLOSE'
      },
      dialogConfirmDelete: {
        title: 'SF Shop',
        bodyMessage: 'Are you sure you want to delete ?',
        delete: 'DELETE',
        cancel: 'CANCEL'
      },
      dialogNotAllowDelete: {
        title: 'SF Shop',
        bodyMessage: 'This address not allow to delete',
        ok: 'OK'
      }
    },
    makeReturn: {
      title: 'RETURN',
      product: 'PRODUCT',
      remark: 'REMARK',
      quantity: 'QUANTITY',
      color: 'COLOR',
      size: 'SIZE',
      selectsuccess: 'Confirm refund',
      dialog: {
        title: 'SF SHOP',
        dialogReturnOrderEmpty: 'Please select item for return.',
        dialogSelectRemark: 'Please select reason for return the product',
        dialogOverMaxFile: 'Allowed to upload image maximum 3 files',
        dialogFileTypeNotSupport:
          'Allowed to upload only image files (.jpg, .png)',
        dialogFileRequired: 'Please upload image minimum 1 file',
        dialogSubmitError:
          'The submit for return product failed, Please try again.',
        close: 'CLOSE'
      },
      captionLabel: {
        details: 'Reasons for changing products',
        upload: 'Upload image files maximun 3 files (.png, .jpg)'
      },
      errorRemark: 'Please enter reasons.'
    },
    return: {
      myReturn: 'MY RETURN',
      notFoundData: 'Your refund order is empty.',
      status: {
        all: 'All',
        wait: 'Considering',
        considered: 'Considered'
      },
      invoiceNo: 'ORDER NO :',
      refundDate: 'RETURN SUBMISSION DATE :',
      refundStatus: 'STATUS :',
      refundHeader: 'RETURN ORDER',
      product: 'PRODUCT',
      quantity: 'QUANTITY',
      remark: 'REMARK',
      details: 'Reasons for changing products',
      reference: 'Reference',
      reply: {
        main: 'Status',
        approve: 'Approved',
        reject: 'Disapproved',
        type: {
          refund: 'Refund',
          change: 'Change Product'
        }
      }
    },
    voucher: {
      myVoucher: 'MY VOUCHER',
      empty: 'Your voucher history is empty.',
      qrCode: 'QR Code',
      barcode: 'Barcode',
      voucherNumber: 'Voucher Number',
      expireDate: 'Expire Date',
      name: 'Name',
      invoiceNo: 'ORDER NO :',
      voucherOrderDate: 'ORDER DATE :',
      status: 'STATUS :',
      product: 'Product',
      price: 'Price',
      quantity: 'Quantity',
      taxInvoiceAddress: 'TAX INVOICE ADDRESS :',
      total: 'Total',
      all: 'ALL',
      failed: 'Failed',
      success: 'Success'
    }
  },
  unableItem: {
    bodyMessage: 'Unable to find that magical item.',
    urlMessage1: 'Back to',
    urlMessage2: 'Home'
  },
  aboutUsPage: {
    items: [
      {
        title: 'จุดเริ่มต้น',
        img: '/assets/img/about-us/about_us_01.jpg',
        paragraph: [
          'เรารู้ดีว่าโลกของภาพยนตร์นั้นเป็นมากกว่า',
          'ที่เราสามารถชมได้ผ่านจอยักษ์กับเสียงที่อลังการในโรงภาพยนตร์',
          'เราเข้าใจดี และรู้ว่ายังมีกลุ่มลูกค้าที่เป็นแฟนตัวยง',
          'ของภาพยนตร์ต่าง ๆ ที่ออกจากโรงภาพยนตร์มาแล้วนั้น',
          'ต้องการที่จะเก็บ สะสม หรือรวบรวมสินค้าลิขสิทธ์แท้ต่าง ๆ',
          'เพื่อเป็นที่ระลึกหรือคุณค่าความทรงจำที่ดีต่อประสบการณ์',
          'ในโรงภาพยนตร์และภาพยนตร์นั้น ๆ'
        ]
      },
      {
        title: 'สร้างความสุข',
        img: '/assets/img/about-us/about_us_02.jpg',
        paragraph: [
          'เราเชื่อว่าทุกคนล้วนมีความสุขกับการได้ดูหนัง',
          'ในโรงภาพยนตร์และมีจินตนาการที่ล้ำลึก',
          'อีกทั้งต้องการสะสมตัวละครต่าง ๆ หรือไอเทมสุดพิเศษ',
          'เพื่อนำไปประดับบ้าน หรือห้องของคุณ'
        ]
      },
      {
        title: ['ใส่ใจ มั่นใจ', 'และตั้งใจ'],
        img: '/assets/img/about-us/about_us_03.jpg',
        paragraph: [
          'เราใส่ใจในการเลือกไอเทมและสินค้าอย่างเต็มที่',
          '',
          'เรามั่นใจว่าสินค้าที่เราเลือกมานั้น มีคุณภาพ',
          'ไม่ว่าจะเป็นความสุขเล็ก ๆ หรือความสุขอันยิ่งใหญ่',
          'เรามั่นใจว่าไอเทมเหล่านี้จะสร้างพื้นที่ความสุขให้กับคุณ',
          'หรือเป็นของขวัญชิ้นพิเศษได้อย่างแน่นอน',
          '',
          'เราตั้งใจทำ SF Shop ให้กับทุก ๆ คน เริ่มตั้งแต่',
          'เสื้อผ้า ของเล่น ตุ๊กตา หรือสินค้าตั้งโชว์',
          'ที่จะมอบช่วงเวลาดี ๆ หลังจากการชมภาพยนตร์'
        ]
      },
      {
        title: 'แล้วยังไงต่อ...',
        img: '/assets/img/about-us/about_us_04.jpg',
        paragraph: [
          'คุณสามารถซื้อสินค้าผ่านช่องทางออนไลน์ของเราได้เพียงไม่กี่คลิก',
          'หรือคุณสามารถเยี่ยมชมร้านของเราได้ที่สาขา',
          {
            text: 'เช็คสาขาได้ที่นี่: ',
            tag: {
              tagName: 'Link',
              text: 'คลิก',
              props: { to: '/branches' }
            }
          }
        ]
      }
    ]
  },
  branchesPage: {
    branch: [
      {
        nameEn: 'SF WORLD CINEMA',
        nameTh: 'เอส เอฟ เวิลด์ ซีเนม่า เซ็นทรัลเวิลด์',
        floor: '7th Floor',
        timeEn: 'Operating Hours : 10:00-22:00',
        timeTh: 'เวลาเปิดทำการ : 10:00-22:00',
        detail: 'บริเวณชั้น 7 ติดบันไดเลื่อนทางขึ้นโรงภาพยนตร์',
        img: '/assets/img/branch/SFW.jpg'
      },
      {
        nameEn: 'SFC MBK CENTER',
        nameTh: 'เอส เอฟ ซีเนม่า เอ็มบีเค เซ็นเตอร์',
        floor: '7th Floor',
        timeEn: 'Operating Hours : 10:00-21:00',
        timeTh: 'เวลาเปิดทำการ : 10:00-21:00',
        detail: 'บริเวณชั้น 7 ตรงข้ามจุดจำหน่ายบัตรชมภาพยนตร์',
        img: '/assets/img/branch/MBK.jpg'
      },
      {
        nameEn: 'SF TERMINAL 21',
        nameTh: 'เอส เอฟ ซีเนม่า เทอร์มินอล 21 อโศก',
        floor: '6th Floor',
        timeEn: 'Operating Hours : 10:00-22:00',
        timeTh: 'เวลาเปิดทำการ : 10:00-22:00',
        detail: 'บริเวณชั้น 6 หน้าบันไดเลื่อนทางเข้าโรงภาพยนตร์',
        img: '/assets/img/branch/T21.jpg'
      },
      {
        nameEn: 'SFC THE MALL BANGKAPI',
        nameTh: 'เอส เอฟ ซีเนม่า เดอะมอลล์ บางกะปิ',
        floor: '4th Floor',
        timeEn: 'Operating Hours : 10:00-21:00',
        timeTh: 'เวลาเปิดทำการ : 10:00-21:00',
        detail: 'บริเวณชั้น 4 หน้าเคาน์เตอร์จำหน่ายบัตรชมภาพยนตร์',
        img: '/assets/img/branch/BKP.jpg'
      },
      {
        nameEn: 'SFX CENTRAL RAMA9',
        nameTh: 'เอส เอฟ เอ็กซ์ ซีเนม่า เซ็นทรัล พระราม 9',
        floor: '7th Floor',
        timeEn: 'Operating Hours : 10:00-22:00',
        timeTh: 'เวลาเปิดทำการ : 10:00-22:00',
        detail: 'บริเวณชั้น 7 หน้าบันไดเลื่อนทางเข้าโรงภาพยนตร์',
        img: '/assets/img/branch/RM9.jpg'
      },
      {
        nameEn: 'SFX CENTRAL CHAENGWATTANA',
        nameTh: 'เอส เอฟ เอ็กซ์ ซีเนม่า เซ็นทรัลพลาซา แจ้งวัฒนะ',
        floor: '7th Floor',
        timeEn: 'Operating Hours : 10:00-22:00',
        timeTh: 'เวลาเปิดทำการ : 10:00-20:00',
        detail: 'บริเวณชั้น 7 หน้าบันไดเลื่อนทางเข้าโรงภาพยนตร์',
        img: '/assets/img/branch/CWN.jpg'
      },
      {
        nameEn: 'SFX THE MALL NGAMWONGWAN',
        nameTh: 'เอส เอฟ เอ็กซ์ ซีเนม่า เดอะมอลล์ งามวงศ์วาน',
        floor: '7th Floor',
        timeEn: 'Operating Hours : 10:00-20:00',
        timeTh: 'เวลาเปิดทำการ : 10:00-20:00',
        detail: 'บริเวณชั้น 7 หน้าบันไดเลื่อนทางเข้าโรงภาพยนตร์',
        img: '/assets/img/branch/NWW.jpg'
      },
      {
        nameEn: 'SFX CENTRAL LARDPRAO',
        nameTh: 'เอส เอฟ เอ็กซ์ ซีเนม่า เซ็นทรัลพลาซา ลาดพร้าว',
        floor: '6th Floor',
        timeEn: 'Operating Hours : 10:00-22:00',
        timeTh: 'เวลาเปิดทำการ : 10:00-22:00',
        detail: ['บริเวณบันไดเลือนทางขึ้น ', 'ทางเข้าโรงภาพยนตร์เทอร์มินอลบี'],
        img: '/assets/img/branch/LPO.jpg'
      }
    ]
  },
  HowToBuyPage: {
    title: 'How to buy',
    select: 'Select products',
    add: 'Add to cart',
    check: 'Check you product',
    payment: 'Choose a payment method',
    shipping: 'Choose shipping'
  },
  dialogProductReview: {
    rating: {
      '1': 'Bad',
      '2': 'Poor',
      '3': 'Average',
      '4': 'Great',
      '5': 'Excellent'
    },
    placeholder: 'Share your experience and help others make better choices!',
    productRating: 'Review product',
    theQualityOfTheProductsIsFair: 'The quality of the products is fair.',
    fairValue: 'Fair value.',
    fastDelivery: 'Fast delivery.',
    shopIsFair: 'Service from the shop is fair.',
    transportationServiceIsFair:
      'The service provided by the transportation service is fair.',
    buttonUploadPicture: 'Upload Picture',
    buttonCancel: 'Cancel',
    buttonConfirm: 'Confirm',
    maxFiles: 'Max 5 files',
    warningMaxFiles: 'Allow to upload up to 5 pictures'
  }
};
